import PushNotificationsFeatureImage from '../../assets/images/push-notifications-feature.png';
import React from 'react';
import { ConfirmModal } from '../../commons/components/ConfirmModal';
import { ExpoUtils } from '../../expo/utils';

export const PushNotificationsModal = (props: { onClose: () => void }) => {
  const { onClose } = props;
  return (
    <ConfirmModal
      title="Enable mobile push notifications"
      footer={{
        type: 'show',
        applyButton: {
          label: 'Enable',
          onClick: () => {
            ExpoUtils.sendMessageToExpo({ type: 'enable-push-notifications-req' });
          },
        },
      }}
      onClose={onClose}
    >
      <div className="release-prompt__content-container">
        <img src={PushNotificationsFeatureImage} alt="Push notifications" width={300} />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            rowGap: '24px',
          }}
        >
          Push notifications help you never miss an invoice, or an important update.
        </div>
      </div>
    </ConfirmModal>
  );
};
